import { Avatar } from "@mui/material";
import PersonIcon from '@mui/icons-material/Person';
import { MYLIST_APP } from "../constants/constants";

export const UserAvatar = ({ user, size = 'small', onClick = () => {} }) => {
    let name = ''
    let imageUrl = null;

    let n = 32;
    let v = 'v1_';
    switch (size) {
        case 'small':
            n = 32;
            v = 'v1_';
            break;
        case 'med':
            n = 64;
            v = 'v2_';
            break;
        case 'large':
            n = 128;
            v = 'v3_';
            break;
    }

    if (user) {
        name = user.name.slice(0, 2).toUpperCase();
        if (user?.profile) {
            imageUrl = `${MYLIST_APP.S3_BUCKET_HOST}/${user.profile.avatar}`;
        }
    }

    return (
        <Avatar src={imageUrl || undefined} sx={{ width: n, height: n }} >
            <PersonIcon />
        </Avatar>
    );
}